import { Box, Column, Typography } from '@tempmee/react';
import {
  CalendarTodayFilterIcon,
  EmptyFavoritesListIcon,
  EmptyRecommendedProsIcon
} from '~/images/emptyScreenIcons';
import { colors } from '@tempmee/tailwind';

const FAVORITE_COPY = {
  title: 'No favorite professionals at this time!',
  description: 'There are three ways you can add a professional to your favorites:',
  steps: [
    {
      title: 'End-of-day review:',
      description: 'Click “Add to Favorites” when prompted to leave a review for a professional.',
    },
    {
      title: 'Completed Shifts screen:',
      description: 'Go to Schedule > Completed Shifts, and view the Shift Details screen.',
    },
    {
      title: 'Professionals Hub:',
      description: 'You can add the professionals you have recently worked with to your favorites.',
    },
  ],
};

const WORKED_WITH_COPY = {
  title: 'No professionals on this list at this time!',
  description:
    "It looks like you haven't completed any shifts yet! Once a professional completes a shift, they will appear on this screen where you will be able send direct invites to upcoming shifts.",
};

const NEW_TO_YOU_COPY = {
  title: 'No new professionals at this time!',
  description:
    'We are searching for professionals who meet the “New to You” criteria in your area. Come back soon to see who we find!',
};

const GLOBAL_COPY = {
  title: 'Invite lists grow with every shift!',
  description:
    "No professionals are available to invite right now. Once you complete a shift with a professional, they'll appear here so you can easily invite them again in the future.",
};

const TITLE_STYLE = { fontSize: 20, marginTop: 18 } as const;
const BODY_TOP_MARGIN = { marginTop: 18 } as const;

export const FavoritesEmpty = () => (
  <Column
    align="center"
    justify="center"
    pt={4}
    data-testid="invite-empty-favorites"
    data-cy="invite-empty-favorites"
    pb={2}
  >
    <EmptyFavoritesListIcon size={136} />

    <Typography bold color={colors.neutral[500]} style={TITLE_STYLE}>
      {FAVORITE_COPY.title}
    </Typography>
    <Column style={{ width: 500, marginTop: 18, gap: 16 }}>
      <Typography color={colors.neutral[500]}>{FAVORITE_COPY.description}</Typography>
      <Box
        as="span"
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 24,
          marginLeft: -20,
          marginTop: 20,
        }}
      >
        {FAVORITE_COPY.steps.map(({ description, title }) => (
          <Box key={title} as="span" style={{ display: 'list-item', marginLeft: 24 }}>
            <Typography as="span" bold color={colors.neutral[500]}>
              {title}
            </Typography>{' '}
            <Typography as="span" color={colors.neutral[500]}>
              {description}
            </Typography>
          </Box>
        ))}
      </Box>
    </Column>
  </Column>
);

export const WorkedWithEmpty = () => (
  <Column
    align="center"
    pt={4}
    data-testid="invite-empty-worked-with"
    data-cy="invite-empty-worked-with"
  >
    <CalendarTodayFilterIcon size={136} />

    <Typography bold color={colors.neutral[500]} style={TITLE_STYLE}>
      {WORKED_WITH_COPY.title}
    </Typography>
    <Typography
      color={colors.neutral[500]}
      textAlign="center"
      style={{ ...BODY_TOP_MARGIN, width: 392 }}
    >
      {WORKED_WITH_COPY.description}
    </Typography>
  </Column>
);

export const NewToYouEmpty = () => (
  <Column
    align="center"
    pt={4}
    data-testid="invite-empty-new-to-you"
    data-cy="invite-empty-new-to-you"
  >
    <EmptyRecommendedProsIcon size={136} />

    <Typography bold color={colors.neutral[500]} style={TITLE_STYLE}>
      {NEW_TO_YOU_COPY.title}
    </Typography>
    <Typography
      color={colors.neutral[500]}
      textAlign="center"
      style={{ ...BODY_TOP_MARGIN, width: 399 }}
    >
      {NEW_TO_YOU_COPY.description}
    </Typography>
  </Column>
);

export const GlobalEmpty = () => (
  <Column
    align="center"
    pt={4}
    data-testid="invite-empty-global"
    data-cy="invite-empty-global"
  >
    <CalendarTodayFilterIcon size={136} />

    <Typography bold color={colors.neutral[500]} style={TITLE_STYLE}>
      {GLOBAL_COPY.title}
    </Typography>
    <Typography
      color={colors.neutral[500]}
      textAlign="center"
      style={{ ...BODY_TOP_MARGIN, width: 399 }}
    >
      {GLOBAL_COPY.description}
    </Typography>
  </Column>
);
